import React from 'react'
import Link from './link'
import { css } from '@emotion/core'
import styled from '@emotion/styled'
import theme from '../../config/theme'
import ubug from '../images/logos/ubug5.svg'
import MobileNav from './mobile-nav'
import Container from './container'
import { bpMaxSM } from '~lib/breakpoints'
import { lighten } from 'polished'

function HeaderLink({ headerColor, ...props }) {
  return (
    <Link
      partiallyActive
      activeClassName="active"
      css={{
        textDecoration: 'none',
        color: headerColor ? headerColor : theme.colors.body_color,
        '&:hover,&:focus': {
          background:
            headerColor === theme.colors.white
              ? 'rgba(40, 28, 77, 0.3)'
              : lighten(0.4, theme.brand.primary),
          color: headerColor === theme.colors.white ? 'white' : theme.colors.link_color_hover,
        },
      }}
      {...props}
    />
  )
}

const NavLink = styled(HeaderLink)({
  padding: '8px 10px',
  borderRadius: '3px',
  background: 'transparent',
  '& + &': { marginLeft: 3 },
  [bpMaxSM]: {
    display: 'none',
  },
  '&.active': {
    background: 'rgba(0, 0, 0, 0.1)',
  },
})

const Header = ({
  dark,
  bgColor = 'none',
  siteTitle,
  headerLink = '/',
  headerColor = 'black',
  fixed = false,
  headerImage = true,
}) => (
  <header
    css={css`
      width: 100%;
      flex-shrink: 0;
      background: none;
      padding: 26px 0 0 0;
      background: ${dark ? '#090909' : `${bgColor}` || 'none'};
      z-index: 10;
      position: ${fixed ? 'fixed' : 'absolute'};
      top: 0;
    `}
  >
    <Container noVerticalPadding>
      <nav
        css={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <HeaderLink
          to={headerLink}
          aria-label="go to homepage"
          headerColor={headerColor}
          css={{
            // display: 'flex',
            alignItems: 'center',
            img: {
              marginBottom: 0,
              maxWidth: '50px',
              borderRadius: '100%',
              display: 'inline-block',
              verticalAlign: 'middle',
              background: headerColor === '#fff' ? 'rgba(40, 28, 77, 0.7)' : '#f1f1f1',
            },
            ':hover, :focus': {
              background: 'transparent',
            },
            span: {
              transform: headerImage && 'translateX(10px)',
              display: 'inline-block',
              verticalAlign: 'middle',
            },
          }}
        >
          {headerImage && <img css={css`
              width: 50px;
              height: 50px;
            `} src={ubug} alt="Ubug" />} <span>{siteTitle}</span>
        </HeaderLink>
        <div
          css={css`
            font-size: 16px;
            line-height: 1.25;
            display: flex;
            align-items: center;
            .mobile-nav {
              display: none;
              visibility: hidden;
              ${bpMaxSM} {
                display: block;
                visibility: visible;
              }
            }
          `}
        >
          <MobileNav color={headerColor} />
          <NavLink headerColor={headerColor} to="/blogs/" aria-label="View blog page">
            📃 文章
          </NavLink>
          <NavLink headerColor={headerColor} to="/studio/" aria-label="View studio page">
            🚧 工作间
          </NavLink>
          <NavLink headerColor={headerColor} to="/talks/" aria-label="View talks page">
            💬 闲说
          </NavLink>
          <NavLink headerColor={headerColor} to="/slides/" aria-label="View sldies page">
            👨‍💻 演示
          </NavLink>
          <NavLink headerColor={headerColor} to="/about/" aria-label="View about page">
            👍 关于我
          </NavLink>
        </div>
      </nav>
    </Container>
  </header>
)

export default Header
